import { Appointment } from 'src/models';

export * from './url';
export * from './browser';

export const getPractitionerName = (appointment: Appointment) => {
  return [
    appointment?.practitioner_title,
    appointment?.practitioner_first_name,
    appointment?.practitioner_last_name,
  ]
    .filter((name) => !!(name || '').trim())
    .join(' ');
};

export const getAppointmentDetailsForAnalytics = (appointment: Appointment) => {
  return {
    appVersion: 2,
    appointment_date: appointment?.appointment_details,
    appointment_id: appointment?.appointment_id,
    appointment_status: appointment?.chat_completion_status,
    practitioner_name: getPractitionerName(appointment),
  };
};
